<div id="irt-vehicles-root-layout" class="irt-full-height">
  <app-toolbar class="irt-toolbar" [currentItem]="navbarItem"></app-toolbar>
  <app-navbar class="irt-navbar" [currentItem]="navbarItem"></app-navbar>
  <app-vehicles-section class="irt-section"></app-vehicles-section>
</div>
